<template>
  <div>
    <v-dialog v-model="showReconciliationDialog" width="640" lazy>
      <reconciliationModal
        @closeDialog="closeReconciliationDialog"
        :bankReconciliationId="currentReconciliationId"
        :noReconciliationMessage="noReconciliationMessage"
      />
    </v-dialog>

    <v-dialog v-model="showFormDialog" width="720" lazy persistent>
      <transactionForm
        @closeBillDialog="closeBillDialog"
        :editedBankTransaction="editedItem"
        :subsidiaryCompanyId="subsidiaryId"
        :key="subsidiaryId"
      />
    </v-dialog>

    <v-layout row wrap class="pa-2">
      <v-flex xs12 class="px-2 py-2">
        <bankInformationsCard :hide_header="true" />
      </v-flex>
    </v-layout>

    <paginatedTable
      :headers="headers"
      store="commonStore"
      getter="bankTransactionsTable"
      :pagination="pagination"
      :graphqlQuery="getGraphqlQuery()"
      resourceName="bank_transactions"
      searchLabel="Search Transactions..."
      :filters="filters"
      :externalFilterString="transactionsFilter"
    >
      <template slot="toolbar_actions">
        <bankToBankTransferForm />
        <v-btn
          small
          depressed
          color="primary"
          class="white--text"
          @click="showCreateDialog"
        >
          <v-icon small class="pr-2">mdi-bank-plus</v-icon>Create transaction
        </v-btn>
      </template>
      <template slot="myItems" slot-scope="props">
        <tr @click="showEditDialog(props.item)">
          <td style="height: 32px;">
            <div style="width: 100%; max-width: 230px;" class="text-truncate">
              <!-- BANK CHARGES and BANK TRANSFER => Display bank information name insteed of company name -->
              <v-tooltip
                bottom
                v-if="
                  props.item.transfer ||
                  props.item.amount == props.item.charges_amount
                "
              >
                <span slot="activator">{{
                  specialCompanyName(props.item)
                }}</span>
                <span>{{ specialCompanyName(props.item) }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <span slot="activator">{{
                  props.item.company
                    ? props.item.company.name
                    : props.item.company_name
                }}</span>
                <span>{{
                  props.item.company
                    ? props.item.company.name
                    : props.item.company_name
                }}</span>
              </v-tooltip>
            </div>
          </td>

          <td style="height: 32px;">
            <div style="width: 100%; max-width: 230px;" class="text-truncate">
              <v-tooltip bottom>
                <span slot="activator">{{ props.item.reference }}</span>
                <span>{{ props.item.reference }}</span>
              </v-tooltip>
            </div>
          </td>

          <td style="height: 32px;">
            <span class="error--text font-weight-bold">{{
              props.item.operation_type == "credit"
                ? ""
                : "- " + inCurrency(props.item.currency.code, props.item.amount)
            }}</span>
          </td>
          <td style="height: 32px;">
            <span class="ctcGreen--text font-weight-bold">{{
              props.item.operation_type == "credit"
                ? inCurrency(props.item.currency.code, props.item.amount)
                : ""
            }}</span>
          </td>
          <td style="height: 32px;">
            <div style="width: 100%; max-width: 120px;" class="text-truncate">
              <v-tooltip bottom>
                <span slot="activator">{{
                  props.item.bank_information.name
                }}</span>
                <span>{{ props.item.bank_information.name }}</span>
              </v-tooltip>
            </div>
          </td>
          <td style="height: 32px;">
            {{
              props.item.payment_date ? timeToDate(props.item.payment_date) : ""
            }}
          </td>
          <td style="height: 32px;">
            <div @click.stop="openReconciliationDialog(props.item)">
              <v-chip>
                <v-icon
                  size="14"
                  class="pr-1"
                  :color="
                    statusColor(
                      statusLabel(
                        props.item.reconciliation_status + '_transaction'
                      )
                    )
                  "
                  >{{
                    statusIcon(
                      statusLabel(
                        props.item.reconciliation_status + "_transaction"
                      )
                    )
                  }}</v-icon
                >
                {{
                  statusLabel(props.item.reconciliation_status + "_transaction")
                }}
              </v-chip>
            </div>
          </td>
          <td style="height: 32px;">
            <v-layout row>
              <v-tooltip bottom>
                <span>Edit</span>
                <v-btn
                  depressed
                  icon
                  small
                  slot="activator"
                  flat
                  color="blue"
                  @click="showEditDialog(props.item)"
                >
                  <v-icon small flat>edit</v-icon>
                </v-btn>
              </v-tooltip>

              <v-tooltip bottom>
                <span>Remove</span>
                <destroyModale
                  :disabled="disableDestroy(props.item)"
                  slot="activator"
                  :icon="true"
                  :small_icon="true"
                  :fab="false"
                  resourceName="bank_transaction"
                  :itemId="props.item.id"
                  :warningText="
                    props.item.transfer
                      ? 'You are going to remove this <b>Bank To Bank Transfer</b> permanently.<br>This action can\'t be undone.'
                      : 'You are going to remove this <b>transaction</b> permanently.<br>This action can\'t be undone.'
                  "
                  small
                  color="ctcRed"
                />
              </v-tooltip>
            </v-layout>
          </td>
        </tr>
      </template>
    </paginatedTable>
  </div>
</template>

<script>
import transactionForm from "./transactionForm";
import reconciliationModal from "../reconciliations/reconciliationModal";
import currency from "../../../mixins/currency";
import paginatedTable from "../../shared/paginatedTable";
import PAGINATED_BANK_TRANSACTIONS_INDEX from "../../../graphql/bank_transactions/paginated_index.gql";
import accountingFilters from "../../../mixins/accountingFilters.js";
import accountingStatus from "../../../mixins/accountingStatus.js";
import date from "../../../mixins/date.js";
import bankToBankTransferForm from "../dashboard/bankToBankTransferForm";
import bankInformationsCard from "../dashboard/bankInformationsCard";

export default {
  name: "bankTransactions",
  components: {
    transactionForm,
    reconciliationModal,
    paginatedTable,
    bankToBankTransferForm,
    bankInformationsCard,
  },
  mixins: [accountingFilters, accountingStatus, currency, date],
  data() {
    return {
      search: "",
      showFormDialog: false,
      editedItem: null,
      showReconciliationDialog: false,
      currentReconciliationId: null,
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
      noReconciliationMessage: null,
      filters: [
        {
          field: "reference",
          label: "Reference",
          type: "text",
        },
        {
          field: "company_id",
          label: "Company",
          getter: "companies",
          itemText: "name",
          type: "resource_id",
        },
        {
          field: "bank_information_id",
          label: "Bank Information",
          getter: "bankInformations",
          itemText: "name",
          type: "resource_id",
        },
        {
          field: "amount",
          label: "Amount",
          type: "float",
          operation: ">",
        },
        {
          field: "operation_type",
          label: "Operation Type",
          type: "enum",
          resources: [
            { text: "All", value: null },
            { text: "Debit", value: "debit" },
            { text: "Credit", value: "credit" },
          ],
        },
        {
          field: "reconciliation_status",
          label: "Reconciliation",
          type: "enum",
          resources: [
            { text: "All", value: null },
            { text: "Done", value: "done" },
            { text: "Partial", value: "partial" },
            { text: "Pending", value: "pending" },
          ],
        },
        {
          field: "created_at",
          label: "Created Before",
          type: "date",
          operation: "<=",
        },
        {
          field: "created_at",
          label: "Created After",
          type: "date",
          operation: ">=",
        },
      ],
      pagination: {
        descending: true,
        rowsPerPage: 25,
        sortBy: "payment_date",
      },
      headers: [
        {
          text: "Customer / Supplier",
          align: "left",
          sortable: false,
          value: "company_name",
        },
        {
          text: "Reference",
          align: "left",
          sortable: true,
          value: "reference",
        },
        {
          text: "Debit",
          align: "left",
          sortable: true,
          value: "amount",
        },
        {
          text: "Credit",
          align: "left",
          sortable: true,
          value: "amount",
        },
        {
          text: "Bank Account",
          align: "left",
          sortable: true,
          value: "bank_information.name",
        },
        {
          text: "Transaction Date",
          align: "left",
          sortable: true,
          value: "payment_date",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          width: "5%",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          width: "5%",
        },
      ],
    };
  },
  methods: {
    disableDestroy(item) {
      return (
        item.reconciliation_status == "done" &&
        !item.transfer &&
        item.amount != item.charges_amount
      );
    },
    specialCompanyName(item) {
      if (item.amount == item.charges_amount) {
        return item.bank_information.name;
      } else if (item.transfer && item.associated_bank_transaction) {
        if (item.operation_type === "credit")
          return (
            "Transfer from " +
            item.associated_bank_transaction.bank_information.name
          );
        else
          return (
            "Transfer to " +
            item.associated_bank_transaction.bank_information.name
          );
      } else {
        return item.company && item.company.name;
      }
    },
    getGraphqlQuery() {
      return PAGINATED_BANK_TRANSACTIONS_INDEX;
    },
    showCreateDialog() {
      this.editedItem = {};
      this.showFormDialog = true;
    },
    showEditDialog(item) {
      this.editedItem = item;
      this.showFormDialog = true;
    },
    closeBillDialog() {
      this.showFormDialog = false;
    },
    closeReconciliationDialog() {
      this.showReconciliationDialog = false;
    },
    openReconciliationDialog(item) {
      this.currentReconciliationId = item.bank_reconciliation_id;
      /* Only charges transactions reconcilation modal handling */
      if (
        item.bank_reconciliation_id === null &&
        item.reconciliation_status === "done"
      ) {
        if (item.charges_amount == item.amount) {
          this.noReconciliationMessage =
            "Bank charge transactions are automaticaly reconciled";
        } else if (item.transfer) {
          this.noReconciliationMessage =
            "Transfer between bank are automaticaly reconciled";
        } else {
          this.noReconciliationMessage =
            "Error status done but no reconciliation found";
        }
      } else this.noReconciliationMessage = null;

      this.showReconciliationDialog = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
td {
  cursor: pointer;
}
</style>
